module.exports = __webpack_public_path__ + "ff727cad7b699ea988326985b847a6a3.pdf";